module.exports = __webpack_public_path__ + "img/checkbox-checked.221a0098.svg";